module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/object-to-processing-9fea28c8b966d5a5362de46357e654fa.svg";